import {nextTick} from 'vue';
import VueMultiselectExtended from '../inputs/multiselect';

const landingEngageMixin = {
    components: {
        Multiselect: VueMultiselectExtended,
    },
    data() {
        return {
            urls: null,
            isBuyLocationMode: null,
            propertyTypes: null,
            currentSellOption: null,
            currentBuyOption: null,
            cityName: null,
        };
    },
    computed: {
        cityNameSuffix() {
            return this.cityName ? `/${this.cityName}` : '';
        },
    },
    methods: {
        initEngageData(settings) {
            this.urls = settings.urls;
            this.isBuyLocationMode = settings.isBuyLocationMode;
            this.propertyTypes = settings.propertyTypes;
            this.currentSellOption = settings.propertyTypes[0];
            this.currentBuyOption = settings.propertyTypes[0];
            this.cityName = settings.dashedCityName;
        },
        createProperty() {
            return this.createListing(this.currentSellOption.value, true);
        },
        createInquiry() {
            return this.createListing(this.currentBuyOption.value, false);
        },
        createListing(propertyType, isProperty) {
            nextTick(() => {
                window.location.href = isProperty ?
                    this.buildPropertyUrl(propertyType) :
                    this.buildInquiryUrl(propertyType);
            });
        },
        buildPropertyUrl(propertyType) {
            return `${this.urls.createPropertyUrl}/${propertyType}${this.cityNameSuffix}`;
        },
        buildInquiryUrl(propertyType) {
            return `${this.urls.createInquiryUrl}/${propertyType}${this.cityNameSuffix}`;
        },
    },
};

export {landingEngageMixin};
